import _ from 'lodash';
import twiaMessages from 'twia-portals-wizard-components-ui/common/TWIAWizardMessages.messages';
import tfpaMessages from 'tfpa-portals-wizard-components-ui/common/TFPAWizardMessages.messages';
import { messages as commonMessages } from '@xengage/gw-platform-translations';

const showSaveErrorPopup = ((showAlert, isTWIA) => {
    if (isTWIA) {
        showAlert({
            message: twiaMessages.TWIACommonErrorMessage,
            status: 'error',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok
        }).catch(_.noop)
    } else {
        showAlert({
            message: tfpaMessages.TFPACommonErrorMessage,
            status: 'error',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok
        }).catch(_.noop)
    }
});

const showQuoteErrorPopup = ((showAlert, isTWIA) => {
    if (isTWIA) {
        showAlert({
            title: twiaMessages.unableToQuote,
            message: twiaMessages.TWIAQuoteErrorMessage,
            status: 'error',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok
        }).catch(_.noop)
    } else {
        showAlert({
            title: tfpaMessages.unableToQuote,
            message: tfpaMessages.TFPAQuoteErrorMessage,
            status: 'error',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok
        }).catch(_.noop)
    }
});

export default {
    'showSaveErrorPopup': showSaveErrorPopup,
    'showQuoteErrorPopup': showQuoteErrorPopup
}